import { render, staticRenderFns } from "./MobileTemplate.vue?vue&type=template&id=60812901&scoped=true"
import script from "./MobileTemplate.vue?vue&type=script&lang=js"
export * from "./MobileTemplate.vue?vue&type=script&lang=js"
import style0 from "./MobileTemplate.vue?vue&type=style&index=0&id=60812901&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60812901",
  null
  
)

export default component.exports